import React from 'react';
import MiniMarketHoursTable from './MiniMarketHoursTable';

const MiniMarketHoursGainers = ({ data }) => {
    return (
        <MiniMarketHoursTable
            type="gainers"
            title="Today Gainers"
            linkTo="/market-movers?tab=gainers"
            data={data}
        />
    );
};

export default MiniMarketHoursGainers;